function PreSubmitEmployeeInformationKenticoForm(target) {
    let form = document.querySelector('form[id*="form-EmployeeInformationForm"]');
    SubmitEmployeeInformationKenticoForm(form);
}

function SubmitEmployeeInformationKenticoForm(event) {
    var form = event;
    var formData = new FormData(form);

    var onResponse = function (event) {
        var contentType = event.target.getResponseHeader("Content-Type");

        if (contentType.indexOf("application/json") === -1) {
            let replaceTarget = form.getAttribute("data-ktc-ajax-update");
            let element = document.createElement('div');
            let ertsGeneralError = document.getElementById('ertsGeneralError');
            element.innerHTML = event.target.response;
            if (element.querySelector('form[id*="form-EmployeeInformationForm"]')) {
                $(replaceTarget).replaceWith(event.target.response);
                ertsGeneralError.classList.add('d-block');
                ertsGeneralError.classList.remove('d-none');
                $(window).scrollTop(ertsGeneralError);
            }
            else {
                replaceTarget = document.querySelector('div[id*="form-EmployeeInformationForm"]');
                ertsGeneralError.classList.remove('d-block');
                ertsGeneralError.classList.add('d-none');
                replaceTarget.innerHTML = event.target.response;
                $(window).scrollTop();
            }
        } else {
            let ertsGeneralError = document.getElementById('ertsGeneralError');
            if (ertsGeneralError) {
                ertsGeneralError.classList.remove('d-block');
                ertsGeneralError.classList.add('d-none');
            }
            var json = JSON.parse(event.target.response);
            location.href = json.redirectTo;
        }
    };

    createEmployeeInformationRequest(form, formData, onResponse);
}

function createEmployeeInformationRequest(form, formData, onResponse) {
    var xhr = new XMLHttpRequest();

    xhr.addEventListener("load", onResponse);

    xhr.open("POST", form.action);
    xhr.send(formData);
}